import { render, staticRenderFns } from "./BigQueryTables.vue?vue&type=template&id=5a244475&"
import script from "./BigQueryTables.vue?vue&type=script&lang=ts&"
export * from "./BigQueryTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports